export function addYourLocationButton (map, locationService, positionChangedCb) {
  let controlDiv = document.createElement('div');

  let firstChild = document.createElement('button');
  firstChild.style.backgroundColor = '#fff';
  firstChild.style.border = 'none';
  firstChild.style.outline = 'none';
  firstChild.style.minWidth = '28px';
  firstChild.style.minHeight = '28px';
  firstChild.style.borderRadius = '2px';
  firstChild.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px';
  firstChild.style.cursor = 'pointer';
  firstChild.style.margin = '10px';
  firstChild.style.padding = '0';
  firstChild.title = 'Your Location';
  controlDiv.appendChild(firstChild);

  let secondChild = document.createElement('div');
  secondChild.style.margin = '5px';
  secondChild.style.minWidth = '18px';
  secondChild.style.minHeight = '18px';
  secondChild.style.backgroundImage = 'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-2x.png)';
  secondChild.style.backgroundSize = '180px 18px';
  secondChild.style.backgroundPosition = '0 0';
  secondChild.style.backgroundRepeat = 'no-repeat';
  firstChild.appendChild(secondChild);

  google.maps.event.addListener(map, 'center_changed', function () {
    secondChild.style['background-position'] = '0 0';
  });

  firstChild.addEventListener('click', ()=>{
    let imgX = '0',
      animationInterval = setInterval(()=>{
        imgX = imgX === '-18' ? '0' : '-18';
        secondChild.style['background-position'] = imgX+'px 0';
      }, 500);

    locationService.subscribe(
      res => {
        let latlng = new google.maps.LatLng(res.lat, res.lng);
        map.setCenter(latlng);
        clearInterval(animationInterval);
        secondChild.style['background-position'] = '-144px 0';
        positionChangedCb(res)
      },
      error => {
        clearInterval(animationInterval);
        secondChild.style['background-position'] = '0 0';
      }
    );
  });

  controlDiv['index'] = 1;
  map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/utils/googleMapsLocationButton.ts